import React from 'react';
import { MdAddCircle, MdDelete, MdVideocam } from "react-icons/md";
import { toast } from 'sonner';

const PropertyVideoUpload = ({ videos, setVideos }) => {

    const handleVideoSelect = (e) => {
        const files = Array.from(e.target.files);
        const oversized = files.filter(f => f.size > 100 * 1024 * 1024); // 100MB limit
        if (oversized.length > 0) {
            toast.error(`${oversized.length} file(s) exceed 100MB limit`);
            return;
        }
        const remaining = 5 - videos.length; // max 5 videos
        const mapped = files.slice(0, remaining).map(file => ({
            file,
            preview: URL.createObjectURL(file),
            name: file.name,
            size: (file.size / (1024 * 1024)).toFixed(2) // MB
        }));
        setVideos(prev => [...prev, ...mapped]);
        e.target.value = "";
    };

    const removeVideo = (previewUrl) => {
        const videoToRemove = videos.find(v => v.preview === previewUrl);
        if (videoToRemove?.preview) URL.revokeObjectURL(videoToRemove.preview);
        setVideos(prev => prev.filter(v => v.preview !== previewUrl));
    };

    return (
        <div className="space-y-3 mt-4">
            <h3 className="text-sm font-semibold text-gray-600 flex items-center gap-1">
                <MdVideocam className="text-base" /> Videos (optional, max 5)
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                {videos.map((vid, index) => (
                    <div
                        key={vid.preview} // ✅ stable key tied to blob URL, not index
                        className="relative rounded-xl overflow-hidden border group bg-black"
                    >
                        <video
                            src={vid.preview}
                            className="w-full h-36 md:h-44 object-cover opacity-80"
                            muted
                            playsInline
                            preload="metadata" // ✅ loads thumbnail frame without full download
                            onMouseEnter={e => e.target.play()}
                            onMouseLeave={e => { e.target.pause(); e.target.currentTime = 0; }}
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-black/50 px-2 py-1">
                            <p className="text-white text-[10px] truncate">{vid.name}</p>
                            <p className="text-gray-300 text-[10px]">{vid.size} MB</p>
                        </div>
                        <button type="button" onClick={() => removeVideo(vid.preview)}
                            className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition shadow-lg"
                        >
                            <MdDelete />
                        </button>
                    </div>
                ))}

                {videos.length < 5 && (
                    <label className="flex flex-col items-center justify-center border-2 border-dashed rounded-xl h-36 md:h-44 cursor-pointer hover:bg-gray-50 transition">
                        <input
                            type="file"
                            multiple
                            accept="video/*"
                            onChange={handleVideoSelect}
                            className="hidden"
                        />
                        <MdAddCircle className="text-2xl text-gray-400 mb-1" />
                        <span className="font-bold text-gray-600 text-xs">Add Videos</span>
                        <span className="text-[10px] text-gray-400">{videos.length}/5 uploaded</span>
                    </label>
                )}
            </div>
        </div>
    );
};

export default PropertyVideoUpload;